import { Box, ColorOptions, Loader, SpacerNew } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/core'
import { useEffect } from 'react'
import { ModBox } from '../../comps/ModifiedBox/ModifiedBox'
import { useLazyApiData, useStores } from '../../data/store'
import { Routes } from '../../nav/routes'
import { Header } from '../CreateCampaign/Header'
import { BasicDetails } from './BasicDetails'
import { Rules } from './Rules'

const CampaignDetails = ({ route }: any) => {
  const id = route?.params?.id
  const {
    fetchCampaignDetails,
    getCampaignDetails,
    mid,
    getStatus,
    canCreateCampaigns,
    updateCampaign,
    setCustomToast,
    getCampaignDetailsWithId,
  } = useStores((store) => ({
    mid: store.user.selectedMid,
    getCampaignDetails: store.campaigns.getCampaignDetails,
    fetchCampaignDetails: store.campaigns.fetchCampaignDetails,
    getLineIndicatorsData: store.campaigns.getLineIndicatorsData,
    updateCampaign: store.campaigns.createCampaign,
    duration: store.campaigns.duration,
    exportCampaign: store.campaigns.exportCampaignReport,
    getTitle: store.campaigns.getTitle,
    getStatus: store.campaigns.getStatus,
    canCreateCampaigns: store.userManagement.canCreateCampaigns(),
    setCustomToast: store.response.setCustomToast,
    getCampaignDetailsWithId: store.campaigns.getCampaignDetailsWithId,
  }))

  const { navigate } = useNavigation()
  const [fetchCampaignDetaisApi, fetchApiHandler] = useLazyApiData(fetchCampaignDetails)
  const [updateCampaignApi, { state }] = useLazyApiData(updateCampaign)
  const [stopCampaignApi, stopApiHandler] = useLazyApiData(updateCampaign)

  useEffect(() => {
    if (state === 'fulfilled' || stopApiHandler?.state === 'fulfilled') {
      setCustomToast({
        message: 'Campaign updated successfully',
        color: 'GREEN',
      })
      navigate(Routes.CAMPAIGNS)
    }
  }, [state, stopApiHandler.state])
  useEffect(() => {
    mid && fetchCampaignDetaisApi(id)
  }, [id, fetchCampaignDetaisApi, mid])

  const status = getStatus(id)

  const onAction = (type: number) => {
    const data = getCampaignDetailsWithId(id)
    status !== 'COMPLETED' && updateCampaignApi(data, id, false, type)
  }

  const onStop = () => {
    const data = getCampaignDetailsWithId(id)
    status !== 'COMPLETED' && stopCampaignApi(data, id, false, 2)
  }

  const titles: any = {
    ACTIVE: 'Pause',
    INACTIVE: 'Resume',
    SCHEDULED: 'Pause',
    PAUSED: 'Resume',
    COMPLETED: 'Resume',
  }

  const actions: any = {
    ACTIVE: 1,
    INACTIVE: 3,
    SCHEDULED: 1,
    PAUSED: 3,
    COMPLETED: 3,
  }
  const details = getCampaignDetails(id)
  return (
    <Box
      backgroundColor="WHITE"
      borderRadius={8}
      justify="space-between"
      shadowRadius={3}
      margin={16}
      shadowColor={'#0000001F' as ColorOptions}
      zIndex={1}
      f={1}>
      <Header
        title={id}
        onProceed={(isDuplicate?: boolean) => navigate(Routes.CREATE_CAMPAIGN, { id: id, isDuplicate: isDuplicate })}
        isDetailsScreen={true}
        status={status}
        canCreateCampaigns={canCreateCampaigns}
        onPause={() => onAction(actions[status] ?? 1)}
        onStop={onStop}
      />
      <ModBox show={fetchApiHandler?.state === 'pending' || state === 'pending' || stopApiHandler?.state === 'pending'}>
        <Loader />
      </ModBox>
      <ModBox
        ph={80}
        f={1}
        overflow={'auto'}
        show={fetchApiHandler?.state !== 'pending' && state !== 'pending' && stopApiHandler?.state !== 'pending'}>
        <SpacerNew direction={'vertical'} size={40} />
        <BasicDetails data={details.campaignDetails} type={'details'} />
        <Rules data={details.rules} />
        <BasicDetails data={details.rewards} type={'rewards'} />
      </ModBox>
      <SpacerNew direction="vertical" size={8} />
    </Box>
  )
}

export { CampaignDetails }
